define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const storage = require('util/storage.util');
    const AuthManager = require('managers/regulation-theme/auth.manager');
    const user = require('user');
    const config = require('config');
    const $ = require('j');
    const server = require('server');
    const languageUtil = require('util/language.util');
    const deviceUtil = require('util/device.util');
    const urlUtil = require('util/url.util');
    const serverUtil = require('util/server.util');
    const { dispatcher, getDeviceId } = require('bundle');

    module.exports = AuthManager.extend({

        _registrationRequest: function(data, requests, options) {
            const def = $.Deferred();
            const token = user.get('signUpVerificationToken');
            const blackbox = this._getIovationBlackbox();
            const request = {
                ID: 31007,
                responses: [31008, 33006],
                description: 'Create Player Info (Register)',
                changeTimestamp: window.Playtech.API.formatter.getDateForIms(new Date()),
                ...this._refineRegistrationData(data),
                ...token && { token },
                ...blackbox && {
                    customData: [
                        {
                            'key': 'iovationBlackbox',
                            'value': blackbox
                        }
                    ]
                }
            };

            server.send(this.registrationRequestFilter(request))
                .done(function(response) {
                    const { playerCode, userId } = response.data;

                    this._afterRegistrationBatchRequest({ ...data, playerCode, userId }, requests)
                        .always(function(msg) {
                            this._successRegistration({ ...data, playerCode, userId }, options);
                            def.resolve(msg);
                        }.bind(this));
                }.bind(this))
                .fail(function(error) {
                    def.reject(error);
                });

            return def.promise();
        },

        _successRegistration: function(data, options) {
            if (options.externalToken) {
                user.set({
                    userId: data.userId,
                    playerCode: data.playerCode,
                    userName: options.personalId,
                    password: options.externalToken,
                    registrationInfo: undefined
                });
            } else {
                user.set({
                    userName: data.loginName || data.userName || data.email,
                    password: data.password,
                    userId: data.userId,
                    playerCode: data.playerCode
                });
            }

            storage.local.setItem('isAfterRegistration', true);
            options.success();
        },

        _refineRegistrationData: function(data) {
            const getAddressDetails = function(val, key) {
                return [
                    'buildingNumber',
                    'propertyNumber',
                    'subbuilding',
                    'streetName',
                    'streetNumber',
                    'unitNumber'
                ].includes(key);
            };
            const addressDetails = _.pick(data, getAddressDetails);
            const dataMap = _.omit(data, getAddressDetails);
            const clientTypeByURL = urlUtil.getLocationParameterByName('clientType');
            const casinoName = config.get('casinoName');
            const clientSkin = config.get('clientSkin');
            const signupClientVersion = config.get('clientVersion');
            const signupUserAgent = deviceUtil.uaOrigin;

            dataMap.clientPlatform = dataMap.clientPlatform || deviceUtil.clientPlatform;
            dataMap.clientType = clientTypeByURL || dataMap.clienttype || config.get('clientType');
            delete dataMap.clienttype;

            return {
                ...casinoName && { casinoName },
                addressDetails: addressDetails,
                dataMap: {
                    ...casinoName && { casinoName },
                    ...clientSkin && { clientSkin },
                    ...signupClientVersion && { signupClientVersion },
                    ...signupUserAgent && { signupUserAgent },
                    ...dataMap
                }
            };
        },

        register: function(options) {
            var def = $.Deferred();
            var lang = languageUtil.convertToIMS(user.get('lang'));
            var formData = user.get('formData');
            var registrationInfo = user.get('registrationInfo');
            var signUpInfo = {
                signupDeviceType: deviceUtil.alias,
                signupOsName: deviceUtil.os,
                signupOsVersion: deviceUtil.osVersion,
                signupDeliveryPlatform: deviceUtil.deliveryPlatform.slice(0, 50),
                signupDeviceBrowser: deviceUtil.browserName
            };
            var data = _.extend({}, formData, signUpInfo);

            if (registrationInfo?.playerHash) {
                data = _.extend({}, data, {
                    playerHash: registrationInfo?.playerHash
                });
            }

            if (!lang) {
                return $.Deferred().reject({
                    ID: -1,
                    data: {
                        errorCode: -1,
                        errorMessage: 'User can\'t be logged in',
                        message: 'Failed to get two letter language'
                    }
                });
            }

            data.language = lang.toUpperCase();

            if (data.userName && config.get('isUsernameInUppercase')) {
                data.userName = data.userName.toUpperCase();
            }

            if (!data.userName && !data.loginName) {
                user.set('loginMode', 'email');
            }

            if (registrationInfo?.externalToken) {
                user.set('loginMode', 'externalToken');
            }

            data.serial = getDeviceId();
            data.signupDeviceId = data.serial;

            var requests = [
                this._generateSubscriptionRequest(data),
                this._getDepositLimitRequest(data),
                this._getBetLimitRequest(data),
                this._getLossLimitRequest(data),
                this._getLoginLimitRequest(data),
            ].filter(Boolean);

            var extendedOptions = _.extend({}, options, {
                externalToken: registrationInfo?.externalToken,
                personalId: data.personalId
            });

            //Batch goes here. We need only registration responses
            this._registrationRequest(data, requests, extendedOptions)
                .done(def.resolve)
                .fail((error) => {
                    options.error();
                    def.reject(error);
                });

            dispatcher.dispatch('registration:submitted');

            return def.promise();
        },

        _getLoginLimitRequest: function(data) {
            var limits = {};

            var limitNames = [
                'monthlyLoginCount',
                'dailyLoginTime',
                'weeklyLoginTime',
                'monthlyLoginTime'
            ];

            limitNames.forEach(function(limitName) {
                if (data[limitName]) {
                    limits[limitName] = data[limitName];
                }
                delete data[limitName];
            });

            return _.keys(limits).length > 0
                ? _.extend(
                    {
                        ID: 35625,
                        responses: [35626, 35627],
                        description: 'Set Player Login Limits'
                    },
                    limits
                )
                : null;
        },

        _afterRegistrationBatchRequest: function(data, requests) {
            return serverUtil.sendBatchRequest(
                requests, data.userName);
        },

        login: function(options) {
            var loginState = $.Deferred();

            if (!window.Playtech.API?.auth?.login) {
                loginState.reject();

                return loginState.promise();
            }

            var userName = user.get('userName');
            var password = user.get('password');
            var rememberMeLogin = user.get('rememberMeLogin');
            var fitToPlay = user.get('fitToPlay');
            var afterRegisterLogin = user.get('afterRegisterLogin');
            var loginMode = user.get('loginMode');

            storage.session.removeItem('fitToPlay');

            if (typeof fitToPlay === 'boolean') {
                storage.session.setItem('fitToPlay', fitToPlay);
            }

            const handleSuccess = (response) => {
                user.unset('password');
                loginState.resolve(response);
                this.sendPlayerTag();
                options.success(response.data);
            };

            const handleError = (error) => {
                if (afterRegisterLogin && error.data?.errorCode === 301) {
                    const popupId = 'registration-recaptcha-popup';

                    Playtech.API.popup.showPopup('reCaptcha', {
                        id: popupId,
                        operation: 'login',
                        onReCaptchaTokenValidate: () => {
                            Playtech.API.popup.closePopups(popupId);
                            window.Playtech.API.auth.login(userName, password, rememberMeLogin, afterRegisterLogin, loginMode)
                                .then(handleSuccess)
                                .catch(handleError);
                        },
                        onClose: () => {
                            // no op
                        },
                        onReCaptchaTokenError: () => {
                            Playtech.API.popup.closePopups(popupId);
                        }
                    });
                }

                loginState.reject(error);
                options.error(error);
            };

            window.Playtech.API.auth.login(userName, password, rememberMeLogin, afterRegisterLogin, loginMode)
                .then(handleSuccess)
                .catch(handleError);

            return loginState.promise();
        },

        sendPlayerTag: function() {
            var playerTagName = config.get('registrationPlayerTagName');
            var pepPlayerTagName = config.get('pepPlayerTagName');
            var privateBankingTagName = config.get('privateBankingPlayerTagName');

            var playerTagValue = storage.session.getItem(playerTagName);
            var isPepTagValueChecked = storage.session.getItem(pepPlayerTagName);
            var isPbTagChecked = storage.session.getItem(privateBankingTagName);

            if (playerTagValue || isPepTagValueChecked || isPbTagChecked) {
                var request = {
                    description: 'Set player tag request',
                    tags: [],
                    ID: 35544
                };

                playerTagValue && request.tags.push({
                    name: playerTagName,
                    type: 'text',
                    value: playerTagValue
                });

                isPepTagValueChecked && request.tags.push({
                    name: pepPlayerTagName,
                    type: 'text',
                    value: true
                });

                isPbTagChecked && request.tags.push({
                    name: privateBankingTagName,
                    type: 'text',
                    value: true
                });

                server.send(request);

                storage.session.removeItem(playerTagName);
                storage.session.removeItem(pepPlayerTagName);
                storage.session.removeItem(privateBankingTagName);
            }
        }
    });
});
